import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Loading } from "@/components/States";
import AuthPage from "@/pages/AuthPage";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import Sell from "@/pages/Sell";
import Saved from "@/pages/Saved";
import Inbox from "@/pages/Inbox";
import Thread from "@/pages/Thread";
import Profile from "@/pages/Profile";
import PublicProfile from "@/pages/PublicProfile";
import Dashboard from "@/pages/Dashboard";
import Pickups from "@/pages/Pickups";
import Notifications from "@/pages/Notifications";
import Admin from "@/pages/Admin";
import Rules from "@/pages/Rules";
import { ForgotPassword, ResetPassword, VerifyEmail } from "@/pages/Recovery";

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const P = (el, admin) => <Protected admin={admin}>{el}</Protected>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Browse />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/listing/:id" element={<ListingDetail />} />
            <Route path="/listing/:id/edit" element={P(<Sell />)} />
            <Route path="/u/:id" element={<PublicProfile />} />
            <Route path="/rules" element={<Rules />} />
            <Route path="/sell" element={P(<Sell />)} />
            <Route path="/saved" element={P(<Saved />)} />
            <Route path="/inbox" element={P(<Inbox />)} />
            <Route path="/inbox/:id" element={P(<Thread />)} />
            <Route path="/profile" element={P(<Profile />)} />
            <Route path="/dashboard" element={P(<Dashboard />)} />
            <Route path="/pickups" element={P(<Pickups />)} />
            <Route path="/notifications" element={P(<Notifications />)} />
            <Route path="/admin" element={P(<Admin />, true)} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
